import { isNumber } from '@costar-ui/utils';

var fallbackRating = [0, 0, 0, 0, 0];
/**
 * Function accepting a number rating which converts it into an
 * array of length 5 who's elements add up to the min(input, 5)
 * which is used to render stars
 *
 * Examples:
 * Input       | Explanation                                   | Output
 * ~ 1         | 1 star rating                                 | [1,0,0,0,0]
 * ~ 5         | 5 star rating                                 | [1,1,1,1,1]
 * ~ 3.2       | 3.2 avg star rating                           | [1,1,1,0.2,0]
 * ~ 5.2       | Greater than 5 is invalid, coerce to no stars | [1,1,1,1,1]
 * ~ 234423    | Greater than 5 is invalid, coerce to no stars | [1,1,1,1,1]
 * ~ -1312     | less than 0, coerce to no stars               | [0,0,0,0,0]
 * ~ -0.2      | less than 0, coerce to no stars               | [0,0,0,0,0]
 * ~ [4]       | can't input arrays, coerce to no stars        | [0,0,0,0,0]
 * ~ null      | invalid input coerces to no stars             | [0,0,0,0,0]
 * ~ undefined | invalid input coerces to no stars             | [0,0,0,0,0]
 */
var convertRatingFloatToArray = function convertRatingFloatToArray(rating, maxRating) {
  if (rating > maxRating || rating < 0 || typeof rating !== 'number') {
    return fallbackRating;
  }
  var integer = Math.floor(rating);
  var decimal = +(rating - integer).toFixed(2);
  var ratings = Array(maxRating).fill(0).fill(1, 0, integer);
  if (integer < 5) {
    ratings[integer] = decimal;
  }
  return ratings;
};
var getStarValues = function getStarValues(rating, maxRating) {
  if (!isNumber(maxRating) || !rating) {
    return fallbackRating;
  }
  if (Array.isArray(rating)) {
    return Array(maxRating).fill('').map(function (_, idx) {
      return rating.includes(idx + 1) ? 1 : 0;
    });
  } else if (rating.toFixed(1).includes('.')) {
    return convertRatingFloatToArray(rating, maxRating);
  }
  return Array(maxRating).fill(1);
};

export { getStarValues };
//# sourceMappingURL=get-star-values.esm.js.map
